import { useContext, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { UserContext } from "@shared/context/user";

const VerifyEmail = () => {
  const { setUser } = useContext(UserContext);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("Verifying...");

  useEffect(() => {
    const token = searchParams.get("token");

    if (token) {
      axios
        .get(`${import.meta.env.VITE_API_URL}/auth/verify?token=${token}`)
        .then((res) => {
          const data = res.data;
          console.log("Verification response:", data);
          setStatus(
            "✅ Your email has been verified. You will now be logged in automatically."
          );
          setTimeout(() => {
            // setUser(res?.data);
            axios.defaults.headers.common[
              "Authorization"
            ] = `Bearer ${data.token}`;
            localStorage.setItem("futureOfTV_User", JSON.stringify(data));
            setUser(data);
            navigate("/asset/webinars");
          }, 3000);
        })
        .catch((err) => {
          setStatus(
            `❌ Verification error. ${err.response?.data?.message || "Please try again later."
            }`
          );
        });
    } else {
      setStatus("❌ No verification token found.");
    }
  }, [searchParams]);

  return (
    <div className="flex justify-center items-center min-h-screen p-4 bg-gray-100 dark:bg-gray-900 text-gray-800 dark:text-white">
      <div className="text-center">
        <h1 className="text-2xl font-bold mb-4">Email Verification</h1>
        <p>{status}</p>
      </div>
    </div>
  );
};

export default VerifyEmail;
